import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
// element-plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCN from 'element-plus/lib/locale/lang/zh-cn'//引入中文
// svg
import SvgIcon from '@/components/SvgIcon/index.vue'
import importAllSvgIcons from './components/SvgIcon'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// mock
// import "@/mock/index";
import '@/styles/index.scss'
// 权限指令
import { PermissionDirective } from '@/directives/permission'

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }
app.component('svg-icon', SvgIcon)
importAllSvgIcons()
app.use(createPinia()).use(ElementPlus, {locale:zhCN})
app.use(router)
app.use(PermissionDirective) // 注册权限指令
app.mount('#app')
